import React, { PropTypes } from 'react';
import { Input } from 'react-bootstrap';
import { titleCase } from '../lib/stringFormatter';
import LoadingSpinner from '../../../shared/js/components/LoadingSpinner';
import HelpBlock from './HelpBlock';
import { isEqual, sortBy } from 'lodash';
import '../../styles/SelectThing';

let SelectThing = React.createClass({
	displayName: 'SelectThing',

	propTypes: {
		disabled: PropTypes.bool,
		error: PropTypes.string,
		feedback: PropTypes.object,
		isFetching: PropTypes.bool,
		nameField: PropTypes.string,
		reduxFormProps: PropTypes.object,
		// When determining the selected thing, `selectedThingId` will be checked first, followed by `reduxFormProps.value`
		selectedThingId: PropTypes.number,
		// If `selectThing` isn't supplied, the component will attempt to use `reduxFormProps.onChange()`
		selectThing: PropTypes.func,
		thingName: PropTypes.string,
		things: PropTypes.array,
		// Set whether or not to remember the value of this control in the state.  Defaults to true
		useLocalStorage: PropTypes.bool,
		zeroThingsMessage: PropTypes.string
	},

	componentWillReceiveProps: function(newProps) {
		let doSelect;

		if (newProps.selectThing) {
			doSelect = newProps.selectThing;
		} else if (newProps.reduxFormProps) {
			doSelect = newProps.reduxFormProps.onChange;
		} else {
			return;
		}

		let thingOrItsId = function(thing) {
			return newProps.selectThing ? thing : thing.id;
		};

		let storedThingId;

		if (!this.props.useLocalStorage) {
			storedThingId = null;
		} else {
			storedThingId = localStorage.getItem(this.props.thingName);
		}

		// If things were received...
		if (newProps.things && newProps.things.length) {
			// And they are a new set of things...
			if (!isEqual(newProps.things, this.props.things)) {
				// Check if the same thing that was selected before can remain selected
				let previousThingId = newProps.selectedThingId;

				if (previousThingId) {
					let matchingThings = newProps.things.filter((thing) => thing.id === parseInt(previousThingId, 10));
					let canKeepCurrentSelection = matchingThings.length > 0;

					if (!canKeepCurrentSelection) {
						// If the current selected thing isn't in the current list of things, arbitrarily select the first
						// item on the new list of things.
						doSelect(newProps.things[0]);
					}
				// Check if a value has been stored in localStorage, and use if so
				} else if (storedThingId) {
					let foundIt = false;

					newProps.things.every((thing) => {
						if (thing.id === parseInt(storedThingId, 10)) {
							foundIt = true;
							doSelect(thingOrItsId(thing));
							return false;
						} else {
							return true;
						}
					});

					if (!foundIt) {
						doSelect(thingOrItsId({ id: undefined }));
					}
				} else if (newProps.things.length === 1) {
					// If there's only one thing, select it
					doSelect(newProps.things[0]);
				}
			}
		} else {
			// If there's no list, call the select function and pass it undefined.
			if (newProps.reduxFormProps && newProps.reduxFormProps.value) {
				newProps.reduxFormProps.onChange(undefined);
			}
		}
	},

	handleSelect: function(event) {
		this.props.things.every((thing) => {
			if (thing.id.toString() === event.target.value.toString()) {
				if (this.props.selectThing) {
					this.props.selectThing(thing);
				} else if (this.props.reduxFormProps) {
					this.props.reduxFormProps.onChange(thing.id);
				}

				if (this.props.useLocalStorage !== false) {
					localStorage.setItem(this.props.thingName, thing.id);
				}

				return false;
			} else {
				return true;
			}
		});
	},

	getSelectedThingId: function() {
		if (this.props.selectedThingId) {
			return this.props.selectedThingId;
		} else if (this.props.reduxFormProps) {
			return this.props.reduxFormProps.value;
		} else {
			return null;
		}
	},

	getOptions: function() {
		let sortedThings = sortBy(this.props.things, this.props.nameField);

		return sortedThings.map((thing) => {
			return (
				<option key={ this.props.thingName + thing.id } value={ thing.id }>
					{ thing[this.props.nameField] }
				</option>
			);
		});
	},

	getContent: function() {
		if (this.props.isFetching) {
			return (<div className="fetching">Loading&nbsp;{ this.props.thingName }s...&nbsp;<LoadingSpinner /></div>);
		} else if (this.props.error) {
			return (<div className="error">Error loading&nbsp;{ this.props.thingName }s:&nbsp;{error}</div>);
		} else if (!this.props.things) {
			return (<div className="none-found">No&nbsp;{ this.props.thingName }s found</div>);
		} else if (this.props.things.length === 0 && this.props.zeroThingsMessage) {
			return (
				<div className="zero-found">
					{ this.props.zeroThingsMessage }
					<HelpBlock help={ (this.props.feedback ? this.props.feedback.help : '') } />
				</div>
			);
		} else {
			return (
				<Input
					disabled={ this.props.disabled }
					type="select"
					label={ titleCase(this.props.thingName) }
					{ ...this.props.reduxFormProps }
					{ ...this.props.feedback }
					value={ this.getSelectedThingId() }
					onChange={ this.handleSelect }
				>
					<option value="" hidden>Select { this.props.thingName }...</option>
					{ this.getOptions() }
				</Input>
			);
		}
	},

	render: function() {
		return (
			<div className="select-thing">
				{ this.getContent() }
			</div>
		);
	}
});

module.exports = SelectThing;



// WEBPACK FOOTER //
// ./frontend/a2i/js/components/SelectThing.jsx